import React from 'react';
import { Route } from 'react-router-dom';
import { TemplatesPage } from './Routes';

export const routes = [<Route key={0} path="/property-templates" component={TemplatesPage} />];

export const navigation = [
    { name: 'property_templates', link: '/property-templates', match: '/property-templates', icon: 'Template' },
];
